<section class="section white-100" *ngIf="_getStartedData">
  <div class="section-container">
    <div class="section-discover-power-text padd-48">
      <div class="discover-power-content-basic align-items-c">
        <ng-container *ngIf="_getStartedData?.header">
          <div class="discover-power-heading align-c">
            {{ _getStartedData?.header }}
          </div>
        </ng-container>
        <ng-container *ngIf="!_getStartedData?.header && _getStartedData?.content">
          <div class="discover-power-heading align-c" [innerHTML]="_getStartedData?.content | toHtml"></div>
        </ng-container>
        <div class="landing-btn align-c">
          <a
            href="{{ _getStartedData?.button1?.url | urlParams:queryParams}}"
            target="{{ getStartedData?.button1?.target }}"
            class="btn btn-full"
            *ngIf="_getStartedData?.button1?.url.includes('exchange.verto')"
            (click)="onGetStartedClick()"
          >
            {{ _getStartedData?.button1.text }}
          </a>
          <app-common-talktosales-button
            [text]="_getStartedData?.button2?.text"
          ></app-common-talktosales-button>
        </div>
      </div>
    </div>
  </div>
</section>
